module.exports = __webpack_public_path__ + "img/06c-osm-emissao-massa.ea6a79b0.png";